import React, { useState } from "react";
import CarsView from "./CarsView";
import BookingsView from "./BookingsView";
import LocationsView from "./LocationsView";
import ImportExportView from "./ImportExportView";
import TopBar from "../components/TopBar";

export default function AdminLayout({ onLogout }) {
  const [view, setView] = useState("cars");

  return (
    <div className="min-h-screen">
      <TopBar view={view} onChangeView={setView} onLogout={onLogout} />
      <main className="max-w-6xl mx-auto px-4 py-6">
        {view === "cars" && <CarsView />}
        {view === "bookings" && <BookingsView onBack={() => setView("cars")} />}
        {view === "locations" && <LocationsView onBack={() => setView("cars")} />}
        {view === "importexport" && <ImportExportView onBack={() => setView("cars")} />}
      </main>
    </div>
  );
}
